import client from "@/lib/api";

// Reference fields for the VIN decoder (dictionary-backed, editable in admin).
export const REF_FIELD_NAMES = {
  fuel_type: "Тип топлива",
  engine_type: "Тип двигателя",
  drive: "Привод",
  body_style: "Тип кузова",
};
export const REF_FIELDS = Object.keys(REF_FIELD_NAMES);

let _cache = null;
let _promise = null;

// Fetch dictionaries from the DB (public endpoint), cached per page load.
export async function getDecoderRefs() {
  if (_cache) return _cache;
  if (!_promise) {
    _promise = client
      .get("/decoder/refs")
      .then((r) => { _cache = r.data || {}; return _cache; })
      .catch(() => ({}));
  }
  return _promise;
}

export function clearDecoderRefsCache() {
  _cache = null;
  _promise = null;
}

// Translate a stored code to the site language; raw text (partsapi) passes through.
export function refLabel(refs, field, value, lang) {
  if (!value) return "";
  const list = (refs && refs[field]) || [];
  const hit = list.find((o) => o.code === value);
  if (!hit) return value;
  return (hit.label && (hit.label[lang] || hit.label.ru)) || value;
}
